import { z } from 'zod';
/** Which source a Job's crew task list follows (Jacky, 22 October 2026, after the Darlington merge: "Apply it to
 *  J-0926-10217 only, through an explicit per-Job switch").
 *
 *  By default the crew tasks come from the Job's newest Proposal (bb.current_installation_scope). A Job listed
 *  here takes them from its quote instead — but only while `quote_id` is still the Job's current quote, so a
 *  later quote change ends the switch by itself instead of silently re-pointing a crew's list. One explicit row
 *  per Job: a blanket rule would also have rewritten scheduled and completed Jobs whose Proposal was built from an
 *  older quote (10189, 10197, 10211, 10228, 10230 on 22 October). */
export const InstallationScopeSchema = z.object({
    follow_quote_jobs: z.array(z.object({
        job_ref: z.string().regex(/^J(?:\d{9}|-\d{4}-\d{5})$/),
        quote_id: z.string().min(1).max(160),
        reason: z.string().trim().min(3).max(500),
    })).max(200).refine(rows => new Set(rows.map(r => r.job_ref)).size === rows.length, { message: 'List each Job once' }),
});
export const installationScopeDefaults = { follow_quote_jobs: [] };
//# sourceMappingURL=installation-scope.js.map